import _createForOfIteratorHelper from "/app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _classCallCheck from "/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "/app/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.values.js";
import { __decorate } from "tslib";
import { Options, Vue } from 'vue-class-component';
import Card from '@/components/layout/Card.vue';
import store from '@/store';
import UserItem from '@/components/users/UserItem.vue';
import UserRightManagementSummary from '@/components/users/UserRightManagementSummary.vue';
import UserRightManagement from '@/components/users/UserRightManagement.vue';
import { AUTH_ITEM_DELETE, AUTH_ITEM_LIST } from '@/store/actions/authItem';
import { AuthItemTypeConfiguration } from '@/store/enums/authItemEnum';
import AuthItemDeleteDialog from '../dialog/AuthItemDeleteDialog.vue';
var AuthItemsTable = /*#__PURE__*/function (_Vue) {
  function AuthItemsTable() {
    var _this;
    _classCallCheck(this, AuthItemsTable);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, AuthItemsTable, [].concat(args));
    _defineProperty(_this, "errorMsg", '');
    _defineProperty(_this, "loading", false);
    _defineProperty(_this, "toggleAuthItemDeleteDialog", false);
    _defineProperty(_this, "authItemToDelete", null);
    return _this;
  }
  _inherits(AuthItemsTable, _Vue);
  return _createClass(AuthItemsTable, [{
    key: "authItems",
    get: function get() {
      return Object.values(store.getters.authItems);
    }
  }, {
    key: "mounted",
    value: function mounted() {
      this.loadAuthItem();
    }
  }, {
    key: "isDeleteAuthItem",
    get: function get() {
      return store.getters.isAuthItemDeleteAivailable;
    }
  }, {
    key: "isUpdateAuthItem",
    get: function get() {
      return store.getters.isAuthItemUpdateAivailable;
    }
  }, {
    key: "isAuthenticationValid",
    value: function isAuthenticationValid(authItem) {
      var value = this.getConfFor(AuthItemTypeConfiguration.SAML_AUTHENTICATION_VALID, authItem) === 'true';
      return value;
    }
  }, {
    key: "getConfFor",
    value: function getConfFor(type, authItem) {
      var _iterator = _createForOfIteratorHelper(authItem.authItemConfigurations),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var authConf = _step.value;
          if (authConf.type === type) {
            return authConf.value;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "loadAuthItem",
    value: function loadAuthItem() {
      var _this2 = this;
      // we load the list of cluster
      this.loading = true;
      store.dispatch(AUTH_ITEM_LIST).then(function (resp) {
        _this2.loading = false;
      }).catch(function (err) {
        _this2.loading = false;
        _this2.errorMsg = err;
      });
    }
  }, {
    key: "deleteAuthItem",
    value: function deleteAuthItem(authItem) {
      this.toggleAuthItemDeleteDialog = true;
      this.authItemToDelete = authItem;
    }
  }, {
    key: "confirmAuthItemDelete",
    value: function confirmAuthItemDelete() {
      var _this3 = this;
      this.toggleAuthItemDeleteDialog = false;
      this.loading = true;
      store.dispatch(AUTH_ITEM_DELETE, this.authItemToDelete.authItemID).then(function () {
        _this3.loading = false;
      }).catch(function (err) {
        _this3.loading = false;
        _this3.errorMsg = err;
      });
    }
  }]);
}(Vue);
AuthItemsTable = __decorate([Options({
  components: {
    UserRightManagement: UserRightManagement,
    UserRightManagementSummary: UserRightManagementSummary,
    UserItem: UserItem,
    Card: Card,
    AuthItemDeleteDialog: AuthItemDeleteDialog
  }
})], AuthItemsTable);
export default AuthItemsTable;